import {html} from 'lit-html';

const { __, sprintf } = wp.i18n;

// NOTE: _n function wp i18n make-pot doesn't like functions as $count variable
const template = (showAvailablePropertiesCount, project) => html`
<div class="project-offer-project-container" data-object-id="${project.getId()}" data-object-status="${project.getStatus()}">
	${(project => {
		if (project.getFeaturedImageSrc()) {
			return html`
			<a class="project-offer-project-featured-image-container" href="${project.getUrl()}">
				<img src="${project.getFeaturedImageSrc()}">
				<span class="project-offer-project-featured-image-action-text">${__('View', 'real-estate-project')}</span>
				<span class="project-offer-project-status">${project.getStatusLabel()}</span>
			</a>
			`;
		}
		else {
			return html`
			<div class="project-offer-project-featured-image-container is-no-image">
				<span class="project-offer-project-status">${project.getStatusLabel()}</span>
			</div>
			`;
		}
	})(project)}
	<div class="project-offer-project-text-container">
		<div class="project-offer-project-header-container">
			<h3 class="project-offer-project-title"><a href="${project.getUrl()}">${project.getName()}</a></h3>
			${project.getLowestPriceObject() ? html `<span class="project-offer-project-price">${sprintf( __('From %s', 'real-estate-project'), project.getLowestPriceObjectPriceFormattedWithComposition())}</span>` : ''}
		</div>
		${showAvailablePropertiesCount && project.getAvailableObjectsCount() ? html`
			<div class="project-offer-properties-available-count">
				${sprintf(__('Still %d available', 'real-estate-project'), project.getAvailableObjectsCount())}
			</div>` : ''}
		<p class="project-offer-project-description">
			${project.getDescription()}
		</p>
		<div class="project-offer-project-footer-container"><a class="button color-gray type-arrow" href="${project.getUrl()}">${__('View', 'real-estate-project')}</a></div>
	</div>
</div>
`;

export default template;